import { createAction, props } from '@ngrx/store';

export interface WhiteLabelConfig {
  id?: number;
  primary_color: string;
  secondary_color: string;
  tertiary_color: string;
  logo_main_url: string;
  logo_iso_url: string;
  logo_white_url: string;
  favicon_url: string;
  background_auth_url: string;
  app_name?: string;
  /** Claim de la marca para el cintillo de los rediseños. Vacío = no se muestra. */
  slogan?: string;
  contact_email?: string;
  contact_phone?: string;
  facebook_url?: string;
  instagram_url?: string;
  twitter_url?: string;
}

export const loadWhiteLabelConfig = createAction('[WhiteLabel] Load Config');

export const loadWhiteLabelConfigSuccess = createAction(
  '[WhiteLabel] Load Config Success',
  props<{ config: WhiteLabelConfig }>()
);

export const loadWhiteLabelConfigFailure = createAction(
  '[WhiteLabel] Load Config Failure',
  props<{ error: string }>()
);
